<template>
  <v-data-table
    :headers="headers"
    mobile-breakpoint="0"
    :items="busStudents"
    :server-items-length="totalItems"
    :items-per-page="10"
    :options.sync="pagination"
    item-key="id"
    loading-text="Đang Tải"
    :loading="loading"
    :footer-props="footerTable"
    sort-by="title"
    no-data-text="Không có dữ liệu"
    disable-sort
  >
    <template v-slot:[`item.student`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.grade`]="{ item }">
      {{ $_get(item, 'grade.title', '-') }}
    </template>
    <template v-slot:[`item.class`]="{ item }">
      <router-link
        style="text-decoration: none"
        :to="'/class/' + $_get(item, 'class.id')"
      >
        {{ $_get(item, 'class.title') }}
      </router-link>
    </template>
    <template v-slot:[`item.buses`]="{ item }">
      <div v-for="bus in item.buses" :key="bus.id" class="d-flex align-center">
        <router-link style="text-decoration: none; white-space: nowrap" :to="'/bus/' + bus.id"
          >{{ bus.name }}
        </router-link>
      </div>
    </template>
    <template v-slot:[`item.edit`]="{ item }">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="red--text" style="cursor: pointer" @click="deleteBusStudent(item.id)"
              >Xóa học sinh</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

const originHeaders = [
  {
    text: 'Tên học sinh',
    value: 'student',
    width: '30%',
  },
  {
    text: 'Khối',
    value: 'grade',
    width: '15%',
  },
  {
    text: 'Lớp',
    value: 'class',
    width: '15%',
  },
  {
    text: 'Tên tuyến',
    value: 'buses',
    width: '40%',
  },
  {
    value: 'edit',
    width: '40%',
  },
]

export default {
  components: { CardStudentName },
  props: {},
  data() {
    return {
      selected: [],
      search: '',
      headers: originHeaders,
      editDialog: false,
      title: '',
      busTableOptions: {},
      busStops: [],
      pagination: {},
    }
  },
  methods: {
    ...mapActions('BusStudents', ['deleteStudent']),
    ...mapActions('BusStudents', ['fetchBusStudents', 'getBusStudentByPagination']),
    deleteBusStudent(id) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa HS khỏi DS đăng ký xe tuyến',
        text: 'Hệ thống sẽ xóa học sinh khỏi mọi điểm dừng trên các tuyến đã đăng ký. Bạn có chắc chắn muốn thực hiện thao tác này?',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: () => {
          this.deleteStudent(id)
        },
      })
    },
  },
  computed: {
    ...mapState('BusStudents', ['studentBuses', 'busStudents', 'pageText', 'totalItems', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'items-per-page-options': [5, 10, 15],
        'page-text': this.pageText,
      }
      return footer
    },
  },

  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.getBusStudentByPagination({ page: newOptions.page, itemsPerPage: newOptions.itemsPerPage })
        }
      },
      immediate: true,
    },
  },
}
</script>
